<script setup lang="ts">

import {inject, onMounted, ref} from "vue";
import {useToastHelper} from "@/helpers/toast.helper";

import type {IApontamentoEntidadeEvent} from "@/domain/events/apontamentoEntidade.event";
import type ApontamentoEntidadeService from "@/domain/services/apontamentoEntidade.service";
import {useModalStore} from "@/stores/modal.store";
import {EModalId, type ModalApontamentoCadastro} from "@/domain/type/modal.type";
import {useAuthStore} from "@/stores/auth.store";

const {showRequestError, showToastSuccess} = useToastHelper();

const modalStore = useModalStore();
const authStore= useAuthStore();

const dialogRef: any = inject('dialogRef');
const isStateComponentError = ref(false);


//entidadeService pode ser qualquer entidade que trablhe com os apontamentos,
// exemplo: ChamadoService, ContratoService, EmepresaService, AssuntoService
// as entidades que trabalham com apontamentos possuem os mesmos metodos para lidar com as operacoes:
// listarApontamento, gravarApontamento, removerApontamento
//
const entidadeService = ref<null | ApontamentoEntidadeService>();
const codigoEntidade = ref<string>("");
let apontamentoEvent : IApontamentoEntidadeEvent | null = null;

const cgpe = ref(authStore.getUserCgpe());


const isLoading = ref(false);

const inputDescricaoApontamento = ref<string>("");
const isDescricaoValida = ref<boolean>(true);


const onGravarApontamento = () => {

  //Valida a entrada da descricao do apontamento
  if (!inputDescricaoApontamento.value || inputDescricaoApontamento.value.toString().trim().length < 5) {
    isDescricaoValida.value = false;
    return false;
  }

  isDescricaoValida.value = true;

  isLoading.value = true;

  (entidadeService.value as ApontamentoEntidadeService)
      .adicionarApontamento({codigoEntidade: codigoEntidade.value, descricao: inputDescricaoApontamento.value.trim(),cgpe:cgpe.value})
      .then(() => {

        showToastSuccess("Apontamento registrado com sucesso!", "");

        //Emite evento de apontamento atualizado
        apontamentoEvent?.emitApontamentoAtualizado(codigoEntidade.value);

        //Fecha o dialog
        onFechar();

      })
      .catch((error) => {
        showRequestError(error);
      })
      .finally(() => {
        isLoading.value = false;
      })


}

const onFechar = () => {

  //Fechar o modal
  //emit("fechar");

  //Se o componente foi aberto atraves de um Dynamic Dialog fecha-o
  if(dialogRef && dialogRef.value){
    dialogRef.value.close();
  }

}


//Carregamento do componente
onMounted(() => {

  //Verifica se o componente foi inicializado de forma correta
  try {

    //Verifica se o modal foi carregado corretamente
    const modalParams = modalStore.getModal(EModalId.modalApontamentoCadastro)?.getParam() as ModalApontamentoCadastro;

    //Verifica se possui informacoes a partir de um DIALOG REF (dialog dinamico)
    if (modalParams) {

      //Verifica se foi informado entidadeService
      if (modalParams.entidadeService) {
        entidadeService.value = modalParams.entidadeService;
      }

      //Verifica se foi informado o codigoEntidade
      if (modalParams.codigoEntidade) {
        codigoEntidade.value =modalParams.codigoEntidade.toString();
      }

      //Verifica se foi informado o evento de apontamento
      if(modalParams.apontamentoEvent){
        apontamentoEvent = modalParams.apontamentoEvent
      }

      //Verifica se foi informado o CGPE
      if(modalParams.cgpe){
        cgpe.value = modalParams.cgpe
      }

    }



    //Define o status erro do componente
    isStateComponentError.value = !(entidadeService.value != null && codigoEntidade.value != "" && cgpe.value != "");

  } catch {
    isStateComponentError.value = true;
  }

});

</script>

<template>

  <div v-if="!isStateComponentError"  @keydown.esc="onFechar">
    <div class="">

      <label class="mb-5">Descrição</label>
      <Textarea @keydown.ctrl.enter="onGravarApontamento" autofocus v-model="inputDescricaoApontamento" rows="6"
                cols="30"
                class="w-full"  :class="{'p-invalid': !isDescricaoValida}"/>

      <small class="p-error" v-if="!isDescricaoValida">Descrição precisa ter pelo menos 5 caracteres</small>
    </div>

    <div class="flex justify-center mt-6 mb-1">
      <Button :loading="isLoading" label="Cancelar" icon="pi pi-times" @click="onFechar" text plain raised/>
      <Button :loading="isLoading" class="ml-4" label="Gravar" icon="pi pi-save" @click="onGravarApontamento"/>
    </div>

  </div>

  <div v-if="isStateComponentError" class="component-state-error ">
    <span class="p-error text-2xl">Component Error</span>
  </div>

</template>

<style scoped>

</style>